import { map, reduce, values } from 'lodash/fp';

import decodeTeam from '../normalizers/decodeTeam';
import decodePlayer from '../normalizers/decodePlayer';

const mapPlayers = map(decodePlayer);
const mapTeams = map(decodeTeam);
const mapEntities = reduce((memo, entity) => {
  const team = memo[entity.positionId];

  return {
    ...memo,
    [entity.positionId]: team
      ? {
          ...memo[entity.positionId],
          selections: [...team.selections, entity]
        }
      : {
          name: entity.positionName,
          abbr: entity.positionAbbr,
          id: entity.positionId,
          selections: [entity]
        }
  };
}, {});

export default function mapSelectionToPositions(selection = {}) {
  const { players, teams } = selection;

  if (!players) {
    return [];
  }

  const entities = [...mapPlayers(players), ...mapTeams(teams)];

  return values(mapEntities(entities));
}
